// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1aSC9","label":"LabeledBox_label__2Rmhl"};